import { render, staticRenderFns } from "./Zinc.vue?vue&type=template&id=c40637ca&scoped=true&"
import script from "./Zinc.vue?vue&type=script&lang=js&"
export * from "./Zinc.vue?vue&type=script&lang=js&"
import style0 from "./Zinc.vue?vue&type=style&index=0&id=c40637ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40637ca",
  null
  
)

export default component.exports